module.exports = __webpack_public_path__ + "fromBrideToParents-we-r.c4c2b3ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-r.jpg
// module id = FXkm
// module chunks = 0